// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"e47ac7a6","163":"41ac99f4","205":"8e1dcc7a"}[chunkId] + ".chunk.js";
};